import { render, staticRenderFns } from "./edit_diction.vue?vue&type=template&id=18e59e67&scoped=true&"
import script from "./edit_diction.vue?vue&type=script&lang=js&"
export * from "./edit_diction.vue?vue&type=script&lang=js&"
import style0 from "./edit_diction.vue?vue&type=style&index=0&id=18e59e67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e59e67",
  null
  
)

export default component.exports